import React from 'react';
import classNames from 'classnames';

import formStyles from 'components/form/appFormField.module.scss';
import { SocialMediaInputProps } from './SocialMediaInput.types';

export const SocialMediaInput = ({ className, ...inputProps }: SocialMediaInputProps) => {
  const inputStyles = classNames('text-input', 'form-control', className);

  return (
    <div className={formStyles.appFormField}>
      <div className={formStyles.inputWrapper}>
        <input className={inputStyles} {...inputProps} />
      </div>
    </div>
  );
};
